import axios from 'axios';
import { SELECTED_ORG_STORAGE_KEY } from 'utils/values';

/**
 * Attaches the admin-selected organization to every admin-panel API request as
 * an `org` query param. The backend honors it only for unrestricted admins
 * (Django staff / superusers) and ignores it for course staff, so this is safe
 * to send unconditionally. localStorage is the single source of truth so the
 * interceptor stays decoupled from the redux store.
 */
axios.interceptors.request.use((config) => {
  const org = localStorage.getItem(SELECTED_ORG_STORAGE_KEY);
  const url = config.url || '';

  if (org && url.includes('adminpanel/')) {
    config.params = { ...(config.params || {}), org };
  }

  return config;
});
